import { MultisidebarItem } from '@/store/multisidebar/types';
import { ItemViewModel } from '@/definitions/view-models';
import { ExternalVms } from '@/api';

export default async function ({ model }: MultisidebarItem<ItemViewModel<ExternalVms>>) {
  return { label: model.item?.verbose_name || model.item?.name || '' };
}
